export default __webpack_public_path__ + "static/media/Dosing-pump-installation.e4e63849.jpg";